import { render, staticRenderFns } from "./KakaoUrl.vue?vue&type=template&id=53798c97&scoped=true"
import script from "./KakaoUrl.vue?vue&type=script&lang=js"
export * from "./KakaoUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53798c97",
  null
  
)

export default component.exports